import { IncomeKeys } from 'pages/CalculatorPage/types';

export const incomeFieldsToCount: IncomeKeys[] = [
  'basicAnnualSalary',
  'basicAnnualSalaryPreviousYear',
  'basicAnnualSalaryRecentYear',
  'bonus',
  'commission',
  'dividendsPreviousYear',
  'dividendsRecentYear',
  'employmentType',
  'guaranteedEmployeeBenefits',
  'netTaxableIncomeRecentYear',
  'overtime',
];
export const benefitsAndCreditsFieldsToCount = ['childBenefit', 'universalTaxCredits', 'stateDisabilityAllowance'];
export const otherIncomeFieldsToCount = ['maintenanceIncome', 'pensionIncome', 'rentalIncome'];

// calculations should be triggered by any of 2 field, but we need only one value
// so both fields use same func, result is right but twice, so I'm just dividing by 2
export const NUMBER_OF_SIMILAR_FIELDS = 2;
